import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';

export default function DetailsCloseButton({ onClick }) {
  return (
    <div className="ShelterDetailsCloseButton">
      <button
        className="ShelterDetailsCloseButton__button ml-auto mb2 flex items-center"
        onClick={onClick}
        type="button"
      >
        <span className="f2 mr1">close</span>
        <Icon name="close" />
      </button>
    </div>
  );
}

DetailsCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
